<div class="confirm-dialog-container" data-cy="confirm-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" data-cy="confirm-header-section">
      <div class="section-header-title" data-cy="confirm-title-text">
       {{ title }}
      </div>
    </div>

<!--    <div class="section-header" >-->
<!--      <div class="section-header-title" >-->
<!--        {{ title }}-->
<!--      </div>-->
<!--      <div style="flex: 1;"></div>-->
<!--    </div>-->

    <!--  MAIN AREA-->

    <div class="section-content" style="flex: 1; text-align: center; margin-top: 12px;"
        [innerHTML]="message"
        data-cy="confirm-message-content"
    >
    </div>



    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="confirm-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button *ngIf="isShowCancel" (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="confirm-cancel-button">Cancel</button>
      <button *ngIf="isShowNo" (click)="onNoClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="confirm-no-button">No</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="confirm-ok-button">Ok</button>
    </div>
  </div>
</div>
